export default function FooterWithCTA(props) {
    return <div className={"bg-white p-4"}>
        <div className={"text-center p-2 w-3/4 mx-auto"}>
            <p className={"text-black mb-5"}>{props.children}</p>
            <a href={props.href} className={"rounded-3xl pt-2 pb-2 pl-4 pr-4 border border-sky-900 text-sky-900 hover:bg-slate-100 hover:cursor-pointer"}>{props.cta}</a>
        </div>
    </div>;
}
